import React, { useEffect, useRef, useState } from 'react'
import { API_URL, BASE_TEMPLATE, UNIQ_GRAPH, USER_SESSION_KEY } from '../../Constants'
import { useNavigate } from 'react-router-dom';
import './AdminConsole.scss';
import axios from 'axios';
import { handleAxiosResponse } from '../../Util';
import Graph from './Graph/Graph';
import { ToastContainer, toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import SankeyUtil from './Graph/SankeyUtil';
import GraphDetails from './GraphDetails/GraphDetails';

export default function AdminConsole() {

    const navigate = useNavigate();

    const graphRef = useRef(null);

    const [graph, setGraph] = useState({}); // the current graph record
    const [graphs, setGraphs] = useState([]);

    const [highlightMode, setHighlightMode] = useState(SankeyUtil.HIGHLIGHT_MODE.COLOR);

    const onLogout = () => {
        localStorage.setItem(USER_SESSION_KEY, null);
        navigate('/');
    }

    const onGraphSaved = async (savedGraphId, mode) => { 
        if(mode==='new'){
            toast.success('Gráfica creada con éxito');
        }else{
            toast.success('Gráfica actualizada con éxito');
        }
        getGraphs(savedGraphId);
    }

    useEffect(()=>{
        getGraphs();
    },[]);

    const getGraphs = async (id) => {
        const serverResponse = await axios.get(`${API_URL}/graph`);
        const foundGraphs = handleAxiosResponse(serverResponse).graphs;
        
        if(UNIQ_GRAPH){
            if(foundGraphs && foundGraphs.length > 0){
                const uniqueGraph = foundGraphs[0];
                if(isEmpty(uniqueGraph.template)){
                    uniqueGraph.template = BASE_TEMPLATE;
                }
                setGraph(uniqueGraph);
            }
        }else{
            setGraphs(foundGraphs);
            if(id){
                const g = foundGraphs.find(g=>g.id==id);
                if(g){
                    setGraph(g);
                } 
            }
        }
    }

    const getGraphMetadata = () => {
        return graphRef.current.getMetadata();
    }

    const onHighlightModeChange = (newValue) => {
        setHighlightMode(newValue);
    }

    const onGraphSelected = (event) => {
        const graphId = event.target.value;
        const selectedGraph = graphs.find(g=>g.id == graphId) || {};
        setGraph(selectedGraph);
    }

    const onNewGraph = ()=>{
        setGraph({});
    }

    return (
        <div className='admin-console'>
            <div className='title-buttons'>
                <span className="hamburger" type='button' onClick={onLogout}>&nbsp;</span>
                <h1>Consola de administración de gráfica</h1>
                <button className="logout primary-button" type='button' onClick={onLogout}>Salir</button>
            </div>
            <div className='header-buttons'>
                {
                    !UNIQ_GRAPH && <>
                        <div>
                            <label htmlFor="graphType"> Gráficas: </label>
                            <select id="graphType" onChange={onGraphSelected} value={!isEmpty(graph)? graph.id : '0'}>
                                <option key="0" value='0'>Seleccione</option>
                                { graphs && graphs.map(g=>(
                                    <option key={g.id} value={g.id}>{g.name}</option>
                                ))}
                            </select>
                            <button type='button primary-button' className='new-button' onClick={onNewGraph}>Nueva</button>
                        </div>
                    </>
                }
            </div>

            <GraphDetails graphRecord={graph} onGraphSaved={onGraphSaved} onHighLightModeChanged={onHighlightModeChange} getGraphMetadata={getGraphMetadata}></GraphDetails>

            {/* Graph */}
            <Graph ref={graphRef} graphRecord={graph} nodeDrag={true} iconDrag={true} nodeTextAnchorChangeEnabled={true} highlightMode={highlightMode} disableCategoryFilters="true"></Graph>

            <ToastContainer autoClose={2000}/>
        </div>
    )
}
